import { render, staticRenderFns } from "./OrderInvoiceSelf.vue?vue&type=template&id=18958d6e&"
import script from "./OrderInvoiceSelf.vue?vue&type=script&lang=js&"
export * from "./OrderInvoiceSelf.vue?vue&type=script&lang=js&"
import style0 from "./OrderInvoiceSelf.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports